module.exports = __webpack_public_path__ + "img/f2-2.134043ea.png";